import React from 'react';
import { Container} from '@chakra-ui/react';
import { HomePage } from './HomePage';

export const Dashboard: React.FC = () => {
  return (
    <Container maxW="container.xl" py={4}>
      <HomePage />
    </Container>
  );
};
